import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { GlobalsService } from './globals.service';
import { BuildInfo } from './build-info';

/**
 * Reads all sorts of configuration information from our resource server
 */
@Injectable({ providedIn: 'root' })
export class ConfigProvider {

  private buildInfoSubject: ReplaySubject<BuildInfo>;

  constructor(private httpClient: HttpClient, private globals: GlobalsService) {

    const observable = this.httpClient.get<BuildInfo>(
      this.globals.adminURL + '/build-info'
    );
    this.buildInfoSubject = new ReplaySubject<BuildInfo>();
    observable.subscribe(this.buildInfoSubject);

  }

  getBackendUrl(): string {
    return this.globals.apiURL;
  }

  fetchBuildInfo(): Observable<BuildInfo> {
    console.log('Fetching build info...');
    return this.buildInfoSubject;
  }
}
